export const isAppEmbedded = (): boolean => {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get('embedded') === 'true';
};
